import createAPI from '@/shared/createAPI';
import Cookies from 'js-cookie'
const MUJI_APP_SSO_LOGIN_HOST = createAPI(process.env.MUJI_APP_SSO_LOGIN_HOST);
const MUJI_APP_SHIED = createAPI(process.env.MUJI_APP_SHIED);
export const submitDataByLogin = (data) => {
    return MUJI_APP_SSO_LOGIN_HOST.postJSON('/login.json', data);
}
export const getAuthZ = (data) => {
    return MUJI_APP_SHIED.getJSON('/getAuthZ.json', data);
}
export const updateAccountPassword = (data) => {
    return MUJI_APP_SHIED.postJSON(`/accountJson/updateAccountPassword.json?token=${Cookies.get('_security_token')}`, data);
}
export const findStaffAccountByCondition = (data) => {
    return MUJI_APP_SHIED.postJSON(`/staffJson/findStaffAccountByCondition.json?token=${Cookies.get('_security_token')}`, data);
}
